export default "__VITE_ASSET__kFLbae16__"